import React from 'react';
import { Typography } from 'antd';
import imagee from '../images/transLogo.svg'

const { Title, Paragraph } = Typography;

const AboutUs = () => {
    return (
        <div className="about-us-container">
            <div className='text-center'>
                <img style={{width:200}} src={imagee} alt="logo" />
            </div>
            <Title>About Us</Title>
            <div className="about-us-content">
                <div className="about-us-section">
                    <Title level={3}>Our Mission</Title>
                    <Paragraph>
                        At Lovodi, our mission is to bring people together, fostering meaningful connections that
                        lead to lifelong relationships. We understand the importance of finding a compatible partner
                        and are committed to helping you discover your perfect match.
                    </Paragraph>
                </div>
                <div className="about-us-section">
                    <Title level={3}>Our Approach</Title>
                    <Paragraph>
                        We combine cutting-edge technology with personalized matchmaking to provide you with a
                        seamless and enjoyable experience. Our team of experts is dedicated to curating a safe and
                        welcoming environment where you can explore potential matches with confidence.
                    </Paragraph>
                </div>
                <div className="about-us-section">
                    <Title level={3}>Contact Us</Title>
                    <Paragraph>
                        Have questions or feedback? Feel free to reach out to us at support@lovodi.com. We value your
                        input and are here to assist you on your journey to finding love.
                    </Paragraph>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
